import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface CountryInfo {
  isSet: boolean;
  asn: string;
  city: string;
  continent_code: string;
  country: string;
  country_area: number;
  country_calling_code: string;
  country_capital: string;
  country_code: string;
  country_code_iso3: string;
  country_name: string;
  country_population: number;
  country_tld: string;
  currency: string;
  currency_name: string;
  in_eu: boolean;
  ip: string;
  languages: string;
  latitude: number;
  longitude: number;
  network: string;
  org: string;
  postal: string;
  region: string;
  region_code: string;
  timezone: string;
  utc_offset: string;
  version: string;
}

export type CountryInfoPayload = Omit<CountryInfo, "isSet">;

export type CountryInfoState = CountryInfo & {
  isLoading: boolean;
};

// New Zealand default data
const initialState: CountryInfoState = {
  isSet: false,
  asn: "",
  city: "Wellington",
  continent_code: "OC",
  country: "NZ",
  country_area: 268021,
  country_calling_code: "+64",
  country_capital: "Wellington",
  country_code: "NZ",
  country_code_iso3: "NZL",
  country_name: "New Zealand",
  country_population: 5122600,
  country_tld: ".nz",
  currency: "NZD",
  currency_name: "Dollar",
  in_eu: false,
  ip: "",
  languages: "en-NZ,mi",
  latitude: -41.2865,
  longitude: 174.7762,
  network: "",
  org: "",
  postal: "",
  region: "Wellington",
  region_code: "WGN",
  timezone: "Pacific/Auckland",
  utc_offset: "+1300",
  version: "IPv4",
  isLoading: false,
};

export const countryInfoSlice = createSlice({
  name: "countryInfo",
  initialState,
  reducers: {
    setCountryInfo: (state, action: PayloadAction<CountryInfoPayload>) => {
      return { ...state, ...action.payload, isSet: true, isLoading: false };
    },
    setCountryLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    clearCountryInfo: () => {
      return initialState;
    },
  },
});

export const { setCountryInfo, setCountryLoading, clearCountryInfo } =
  countryInfoSlice.actions;

export default countryInfoSlice.reducer;
